import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Icon } from 'antd';

import PopoverError from '../commons/popoverError';
import ImatgeAmbControlError from '../commons/imatgeAmbControlError';

import {
    crearNotificacioFotoSuperaMidaPermesa,
    crearNotificacioFotoTipusNoPermes
} from '../../commons/notificacio';

import {
    extensionsPermesesEnString,
    fitxerTipusNoPermes
} from '../../commons/gestioImatges';

const midaMaximaPermesaImatgeEnMB = 5;
const unitatImatge = 'MB';

const fitxerSuperaMidaMaximaPermesa = (midaFitxerEnMB) => {
    return midaFitxerEnMB > midaMaximaPermesaImatgeEnMB;
};

class AvisIntroduccioSeccioDadesMeteorCampFoto extends Component {

    constructor(props) {
        super(props);

        const urlImatgeOriginal = props.camp.valor || '';

        this.state = {
            urlImatgeOriginal: urlImatgeOriginal,
            urlImatgeSeleccionada:  urlImatgeOriginal
        };

        this.modificarImatgeSeleccionada = this.modificarImatgeSeleccionada.bind(this);
        this.seleccionarImatge = this.seleccionarImatge.bind(this);
        this.eliminarImatgeSeleccionada = this.eliminarImatgeSeleccionada.bind(this);
    }

    modificarImatgeSeleccionada(fitxer) {
        const tipusFitxer = fitxer.type;
        const idCamp = this.props.camp.id;
        const midaFitxerEnMB = ((fitxer.size/1000)/1000).toFixed(2);

        if (fitxerTipusNoPermes(tipusFitxer)) {
            crearNotificacioFotoTipusNoPermes();
            return;
        }

        if (fitxerSuperaMidaMaximaPermesa(midaFitxerEnMB)) {
            crearNotificacioFotoSuperaMidaPermesa(midaFitxerEnMB, unitatImatge, midaMaximaPermesaImatgeEnMB);
            return;
        }

        this.props.onModificarValor(idCamp, fitxer);

        const obtenirUrlImatgeSeleccionada = (fitxer) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                this.setState({urlImatgeSeleccionada: event.target.result});
            };
            reader.readAsDataURL(fitxer);
        };

        obtenirUrlImatgeSeleccionada(fitxer);
    }

    seleccionarImatge() {

        // si l'input té emmagatzemada una imatge, cal netejar-lo
        if (this.inputHTML5.value) {
            this.inputHTML5.value = '';
        }

        //es força un clic a l'element input d'HTML5
        this.inputHTML5.click();
    }

    eliminarImatgeSeleccionada() {
        const idCamp = this.props.camp.id;
        this.props.onModificarValor(idCamp, null);
        this.props.modificarUrlFotoAEliminar(this.state.urlImatgeOriginal);
        this.setState({urlImatgeSeleccionada: null});
    }

    render() {

        const urlImatgeSeleccionada = this.state.urlImatgeSeleccionada;
        const { camp } = this.props;
        const { error, nom } = camp;

        // input de tipus "file" d'HTML5, resta ocult però s'usa la funcionalitat de seleccionar arxiu
        const inputHTML5 = (
            <input
                ref={ref => this.inputHTML5 = ref}
                type='file'
                accept={extensionsPermesesEnString}
                onChange={(event) => this.modificarImatgeSeleccionada(event.target.files[0])} />
        );

        // previsualització de la imatge seleccionada
        const previsualitzacioImatge = (
            <div className='avis-introduccio-seccio-dades-meteor-camp-foto-contenidor-imatge-seleccionada'>
                <ImatgeAmbControlError url={urlImatgeSeleccionada} />
                <div className='avis-introduccio-seccio-dades-meteor-camp-foto-contenidor-imatge-seleccionada-eliminar'>
                    <Icon
                        style={{color: 'white', fontSize: 20}}
                        type='delete'
                        onClick={this.eliminarImatgeSeleccionada} />
                </div>
            </div>
        );

        // zona que cal clicar quan es vol seleccionar una imatge
        const selectorImatge = (
            <div className='avis-introduccio-seccio-dades-meteor-camp-foto-contenidor-imatge-afegir'
                onClick={this.seleccionarImatge}>
                <Icon type='plus' style={{fontSize: 20}} />
            </div>
        );

        const errorRenderitzat = (error) ? <PopoverError contingut='Camp obligatori' /> : null;

        return (
            <div className='avis-introduccio-seccio-dades-meteor-camp'>
                <span className='titol'>
                    {nom}:
                </span>
                <div className='avis-introduccio-seccio-dades-meteor-camp-foto'>
                    {inputHTML5}
                    {urlImatgeSeleccionada ? previsualitzacioImatge : selectorImatge}
                </div>
                {errorRenderitzat}
            </div>
        );
    }
}

AvisIntroduccioSeccioDadesMeteorCampFoto.propTypes = {
    camp: PropTypes.object.isRequired,
    onModificarValor: PropTypes.func.isRequired,
    modificarUrlFotoAEliminar: PropTypes.func.isRequired
};

export default AvisIntroduccioSeccioDadesMeteorCampFoto;



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteorCampFoto.js